import script from "./ScheduleSetupStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduleSetupStep.vue?vue&type=script&setup=true&lang=ts"

import "./ScheduleSetupStep.vue?vue&type=style&index=0&id=35a49724&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a49724"]])

export default __exports__